export default __webpack_public_path__ + "static/media/i_topport.cc08adf4.svg";